import { IMockProps } from '_core/types';
import { ENDPOINT_API_PATH } from '../Definitions/ValidateLegalGuardianDef';

const autoGenerateSuccess = () => {
  const validateSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
    },
    configResponse: {
      status: 200,
      data: {},
    },
  };
  return validateSuccess;
};

const generatedSuccessMocks = [autoGenerateSuccess()];

const MemberInfo = [...generatedSuccessMocks];
export default MemberInfo;
